// extracted by mini-css-extract-plugin
export default {"tooltip":"zQ-z","arrow":"AQ-z"};